module.exports = __webpack_public_path__ + "img/Frame4312.5ede9901.jpg";